import { getAxiosBackendApi2 } from "../helpers/axios"

class PlotsOfLandServices{

    constructor(){
    }

    addInjured(data){
        return getAxiosBackendApi2().post('woundeds', data)
    }

    addMartyr(data){
        return getAxiosBackendApi2().post('martyrs', data)
    }
}

export default new PlotsOfLandServices()